/**
 * Generates the Authorization header for a request to the server.
 * If serverToken is provided, the function will return an Authorization header
 * with a value of 'application/json'. Otherwise, it will return an empty string.
 *
 * @param {string} serverToken - The server token to add to the Authorization header.
 * @return {string} The Authorization header to add to the request, or an empty string.
 */
function getAuthorizationHeader(serverToken) {
    if (serverToken) {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${serverToken}`,
            'Accept': 'application/json'
        };
    }
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    };
}

export default getAuthorizationHeader;
